import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy bg-light">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container py-3">
          <a className="navbar-brand fw-bold" href="/" style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800 }}>
            <span className="text-primary">Aim</span>
            <span className="text-warning">Fit</span>
          </a>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <a className="nav-link" href="/#features">Features</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#philosophy">Philosophy</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#download">Download</a>
              </li>
            </ul>
            <a href="/" className="btn btn-outline-primary">Back to Home</a>
          </div>
        </div>
      </nav>

      <div className="container py-5">
        <h1 className="text-primary mb-4">Privacy Policy</h1>
        <p className="text-secondary fst-italic mb-5">Last Updated: March 17, 2025</p>

        <p>Welcome to AimFit. We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our mobile application.</p>

        <h2 className="text-primary mt-5 mb-3">1. Information We Collect</h2>
        <p>AimFit collects only the minimum amount of data necessary to provide our services:</p>
        <ul className="text-secondary">
          <li className="mb-2"><strong>Health and Fitness Data:</strong> With your explicit permission, we access workout data from Apple Health, including calories burned during exercise activities. This data is only read from your device and is not transmitted to our servers.</li>
          <li className="mb-2"><strong>User Preferences:</strong> We store your in-app settings and preferences (such as your goal type, calorie goals, weight units) locally on your device.</li>
          <li className="mb-2"><strong>Usage Data:</strong> Basic app usage information to improve the application functionality.</li>
        </ul>

        <h2 className="text-primary mt-5 mb-3">2. How We Use Your Information</h2>
        <p>The information we collect is used solely for the following purposes:</p>
        <ul className="text-secondary">
          <li className="mb-2">To provide and maintain our service</li>
          <li className="mb-2">To track your fitness progress as displayed within the app</li>
          <li className="mb-2">To improve the functionality and user experience of our application</li>
        </ul>
        <p>We do not use your data for marketing purposes, advertising, or share it with third parties.</p>

        <h2 className="text-primary mt-5 mb-3">3. Data Storage and Security</h2>
        <p>All of your fitness data and preferences are stored locally on your device. AimFit does not transmit or store your personal health data on external servers. Your privacy and data security are our priority.</p>

        <h2 className="text-primary mt-5 mb-3">4. Children's Privacy</h2>
        <p>AimFit can be used by children under the age of 13. However, we do not knowingly collect personally identifiable information from children. The app only accesses workout data from Apple Health with explicit permission, and this data remains on the device.</p>
        <p>We encourage parents and guardians to monitor their children's use of all mobile applications. If you believe we have collected personal information from a child under 13 without appropriate consent, please contact us, and we will promptly remove such information.</p>

        <h2 className="text-primary mt-5 mb-3">5. Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.</p>
        <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

        <h2 className="text-primary mt-5 mb-3">6. Your Rights</h2>
        <p>Depending on your location, you may have certain rights regarding your personal information, such as:</p>
        <ul className="text-secondary">
          <li className="mb-2">The right to access information we have about you</li>
          <li className="mb-2">The right to correct any inaccurate information</li>
          <li className="mb-2">The right to delete your information</li>
          <li className="mb-2">The right to withdraw consent</li>
        </ul>
        <p>Since AimFit primarily stores information locally on your device, most control over your data is directly in your hands. You can delete the app or revoke Apple Health permissions at any time.</p>

        <h2 className="text-primary mt-5 mb-3">7. Third-Party Services</h2>
        <p>AimFit integrates with Apple Health to read your workout data. Please review Apple's Privacy Policy to understand how they handle your health data.</p>

        <div className="contact bg-light bg-opacity-75 border p-4 rounded-3 my-5">
          <h2 className="text-primary mb-3">8. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us:</p>
          <p>Email: contact@aimfit.me</p>
          <p>Website: https://aimfit.me</p>
        </div>

      </div>

      {/* Footer */}
      <footer className="bg-light py-4 border-top">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="mb-3 mb-md-0">
            <span
              className="fs-4 text-primary"
              style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800 }}
            >
              Aim
            </span>
            <span
              className="fs-4 text-warning"
              style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800 }}
            >
              Fit
            </span>
          </div>
          <div className="text-secondary small">
            &copy; {new Date().getFullYear()} AimFit. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;